<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">My book was damaged when I got it</h1>

			<div class="h-email-form" v-if="loaded">
				<email-form
						subject="My Rental item was damaged"
						:body="mail_body"
						on-success-url="/help?#/submitted"
						edit-body
						attach-screenshot
						require-screenshot
						:payload="{ order_line_id }"
						destination-key="oq"
				></email-form>
			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';
	import Axios from 'axios';

	export default {
		name: "HelpRentalBookDamaged",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				loading: false,
				loaded: false,
				order_id: null,
				order_line_id: null,
				isbn: null,
			}
		},

		computed: {
			mail_body() {
				return `My rental item had an issue, when it arrived it was damaged.`;
			}
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data) {
						let d = response['data']['data'];
						self.order_id = d['order_id'];
						self.order_line_id = parseInt(self.$route.params.id);
						self.isbn = d['book_isbn'];
						self.loaded = true;
					}
				})
				.finally(function () {
					self.loading = false;
				});
		}
	}
</script>

<style scoped>

</style>